import React from 'react';
import styled from 'styled-components';
import { media } from '../../utils/media';
import Skeleton from '../../ui/atoms/Skeleton';

// Wrapper styled similarly to AllCoursesWrapper
const SkeletonWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: 24px;
  
  ${media.lessThan('tablet')} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${media.lessThan('phablet')} {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const CourseCardSkeleton = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const CardImageWrapper = styled.div`
  height: 160px;
`;

const CardContentSkeleton = styled.div`
  padding: 16px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const ListCoursesSkeleton = ({ count = 6, showProgress = false, showButtons = false }) => {
  return (
    <SkeletonWrapper>
      {Array.from({ length: count }).map((_, index) => (
        <CourseCardSkeleton key={index}>
          <CardImageWrapper>
            <Skeleton.Base height="100%" />
          </CardImageWrapper>
          <CardContentSkeleton>
            <Skeleton.Circle 
              size="40px"
              margin="0 0 12px 0"
            />
            <Skeleton.Text 
              height="24px" 
              width="80%" 
              margin="0 0 12px 0"
            />
            <Skeleton.Text 
              height="14px" 
              width="90%" 
              margin="0 0 8px 0"
            />
            <Skeleton.Text 
              height="14px" 
              width="75%" 
              margin="0 0 8px 0"
            />
            
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '16px' }}>
              <Skeleton.Text height="36px" width="45%" />
              <Skeleton.Text height="36px" width="45%" />
            </div>
            
          </CardContentSkeleton>
        </CourseCardSkeleton>
      ))}
    </SkeletonWrapper>
  );
};

export default ListCoursesSkeleton;
